import { SyncStatusResponseSchema, SyncTriggerResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type SyncTriggerResponseInput = z.input<typeof SyncTriggerResponseSchema>;
export type SyncTriggerResponseOutput = z.output<typeof SyncTriggerResponseSchema>;

export function serializeSyncTriggerResponse(payload: SyncTriggerResponseInput): SyncTriggerResponseOutput {
  return SyncTriggerResponseSchema.parse(payload);
}

export type SyncStatusResponseInput = z.input<typeof SyncStatusResponseSchema>;
export type SyncStatusResponseOutput = z.output<typeof SyncStatusResponseSchema>;

export function serializeSyncStatusResponse(payload: SyncStatusResponseInput): SyncStatusResponseOutput {
  return SyncStatusResponseSchema.parse(payload);
}
